import React from 'react'
import * as ReactDOM from 'react-dom'
import { uid } from 'react-uid/dist/es5/index'

import '../Message.css'
import Button from '../TemplateMessage/Button'
import QuickReplyList from '../Reply/QuickReplyList'
import { generatePostBackObject } from '../../../actions/static'
import { generateNewTabName } from '../../../helper/generateNewTabName'
import { getMessageLogo } from '../../../helper/getMessageLogo'
import { wrapTextAddLinks } from '../../../helper/wrapTextAddLinks'

const messageWidthBtn = screenWidth => ({
  width: screenWidth ? (screenWidth * 70) / 100 + 'px' : '254px',
  whiteSpace: 'pre-wrap',
})
const messageWidthText = (screenWidth, color, messageBorder, isRtl) => ({
  maxWidth: screenWidth ? (screenWidth * 70) / 100 + 'px' : '254px',
  whiteSpace: 'pre-wrap',
  backgroundColor: color ? color : '',
  borderRadius: messageBorder,
  direction: isRtl && 'rtl',
})

class TextMessage extends React.Component {
  componentDidMount() {
    this.linkEditorListener()
  }

  linkEditorListener = () => {
    const links = [
      ...ReactDOM.findDOMNode(this.output).querySelectorAll('.linkEdited'),
    ]
    links.length > 0 &&
      links.forEach(link => {
        const extension = JSON.parse(link.getAttribute('data-extension'))
        const url = link.getAttribute('data-href')

        if (extension) {
          link.onclick = () => this.props.openIframe(url)
        } else {
          link.onclick = () => this.openNewTab(url)
        }
      })
  }

  openNewTab = url => {
    window.open(url, generateNewTabName())
  }

  render() {
    const {
      classesNames,
      postMessage,
      message,
      showReply,
      showLogo,
      device,
      settings,
      openIframe,
      isFullScreenWidget,
      messageBorder,
      messageMargin,
      isMobile,
    } = this.props
    const containerClass =
      classesNames && ~classesNames.indexOf('bubble--sent')
        ? 'msg--sent'
        : 'msg--rcvd'
    const color =
      classesNames && ~classesNames.indexOf('bubble--sent')
        ? settings.color
        : '#ebebef'
    const { isRtl, isFromBot } = message

    const wrapClass =
      isFromBot && showLogo ? 'received-container_logo' : 'received-container'

    return (
      <>
        {message.buttons != null ? (
          <div ref={node => (this.output = node)} className={wrapClass}>
            {isFromBot && showLogo && (
              <div className="received-logo">
                <img
                  width={32}
                  height={32}
                  src={getMessageLogo(message, settings)}
                  alt=""
                  className="bot-logo"
                />
              </div>
            )}
            <div
              className="msg_container-button"
              style={messageWidthBtn(device.width)}>
              <div
                style={messageWidthBtn(device.width)}
                className={`msg_button ${containerClass}`}>
                <span
                  className={classesNames}
                  style={{ direction: isRtl && 'rtl' }}
                  dangerouslySetInnerHTML={{
                    __html: wrapTextAddLinks(message.text),
                  }}
                />
              </div>
              {message.buttons &&
                message.buttons.map(button => (
                  <Button
                    button={button}
                    key={uid(button)}
                    title={button.title}
                    openIframe={openIframe}
                    style={{ color: settings.color }}
                    onClick={() => postMessage(generatePostBackObject(button))}
                  />
                ))}
            </div>
          </div>
        ) : (
          <div
            ref={node => (this.output = node)}
            className={`msg-container ${containerClass} ${wrapClass}`}
            style={{ margin: messageMargin }}>
            {isFromBot && showLogo && (
              <img
                className="received-logo bot-logo"
                src={getMessageLogo(message, settings)}
                alt=""
              />
            )}
            <span
              className={classesNames}
              style={messageWidthText(
                device.width,
                color,
                messageBorder,
                isRtl,
              )}
              dangerouslySetInnerHTML={{
                __html: wrapTextAddLinks(message.text),
              }}
            />
          </div>
        )}
        {showReply && message && (
          <QuickReplyList
            isMobile={isMobile}
            message={message}
            color={settings.color}
            postMessage={postMessage}
            isFullScreenWidget={isFullScreenWidget}
          />
        )}
      </>
    )
  }
}

export default TextMessage
